import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiGlobe } = FiIcons;

export default function Footer() {
  const logoUrl = "https://i.postimg.cc/mgsj3n1B/Profit-Lense-Ai-removebg-preview-1-e1761938877150-re14vm2sctdm5afac5mt1eumkxkt6ihxc8sqlln5a0.png";

  return (
    <footer className="bg-[#05080F] border-t border-gray-800/60 pt-16 pb-8 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-12">
          <a 
            href="https://profitlense.ai" 
            className="flex items-center gap-3 group transition-opacity hover:opacity-80"
          >
            <div className="w-12 h-12 flex items-center justify-center">
              <img 
                src={logoUrl} 
                alt="ProfitLense.AI Logo" 
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-xl font-bold tracking-tight text-white">
              ProfitLense<span className="text-blue-400">.AI</span>
            </span>
          </a>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-8 items-center">
            <a href="mailto:support@profitlense.ai" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2 text-sm">
              <SafeIcon icon={FiMail} /> support@profitlense.ai
            </a>
            <a href="https://www.profitlense.ai" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2 text-sm">
              <SafeIcon icon={FiGlobe} /> www.profitlense.ai
            </a>
          </div>
        </div>
        <div className="border-t border-gray-800/60 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm text-center md:text-left">
            © 2026 ProfitLense.AI. All Rights Reserved.
          </p>
          <div className="flex gap-4 text-sm text-gray-500">
            <span className="hover:text-gray-300 cursor-pointer transition-colors">Privacy Policy</span>
            <span>•</span>
            <span className="text-blue-400 cursor-pointer">Terms & Conditions</span>
          </div>
        </div>
      </div>
    </footer>
  );
}